import activision from '../../img/activision.jpg';
import amazon from '../../img/amazon.png';
import airbnb from '../../img/airbnb.jpg';
import meta from '../../img/meta.png';

export const jobSearches = [
  {
    id: 1,
    search: 'Frontend Developer',
    location: 'Dublin, Ireland',
    hits: 230,
  },
  {
    id: 2,
    search: 'Junior Web Developer',
    location: 'European Economic Area',
    hits: 2600,
  },
  {
    id: 3,
    search: 'Full Stack Developer',
    location: 'London, England',
    hits: 650,
  },
  {
    id: 4,
    search: 'Web Developer Internship',
    location: 'European Union',
    hits: 302,
  },
  {
    id: 5,
    search: 'Market Specialist',
    location: 'Warsaw, Poland',
    hits: 6,
  },
  {
    id: 6,
    search: 'Content Review',
    location: 'Republic of Ireland',
    hits: 26,
  },
  {
    id: 7,
    search: 'Insurance Claims',
    location: 'Madrid, Spain',
    hits: 16,
  },
];

export const recommendedJobs = [
  {
    id: 1,
    title: 'Junior Frontend Engenieer',
    company: 'Activision',
    location: 'Dublin, Ireland',
    posted: '2 days ago',
    img: activision,
  },
  {
    id: 2,
    title: 'UI/UX Researcher',
    company: 'Amazon',
    location: 'Ireland, Remote',
    posted: '3 days ago',
    img: amazon,
  },
  {
    id: 3,
    title: 'React Developer',
    company: 'Meta',
    location: 'Remote',
    posted: '4 days ago',
    img: meta,
  },
  {
    id: 4,
    title: 'Full Stack Developer',
    company: 'Meta',
    location: 'Remote',
    posted: '4 days ago',
    img: airbnb,
  },
];
